import { isConnectionFailure } from './connection-failure';
import { getErrorStatusCode } from './error-status';

/** Answers from a proxy or an engine that is not up yet, rather than from a request the engine ran. */
const TRANSIENT_STATUS_CODES: ReadonlySet<number> = new Set([502, 503, 504]);

/**
 * Whether a failure is worth another attempt: the engine was unreachable, the request timed out, or
 * a gateway answered in its place. A 4xx is caused by the request itself, so retrying only
 * reproduces it, and anything that is not recognisably a fetch failure is left alone.
 *
 * A plain 500 is not retried: the engine currently answers 500 for deterministic failures too
 * (validation, unsupported queries, driver errors), so retrying would loop on them forever.
 *
 * TODO: the engine has no typed error codes on this path yet (`crates/error/src/codes.rs`), so this
 * reads the HTTP status and ofetch's error shape. Classify by error code once the backend
 * categorizes its errors.
 */
export function isTransientError(error: unknown): boolean {
	const statusCode = getErrorStatusCode(error);

	if (statusCode !== undefined) return TRANSIENT_STATUS_CODES.has(statusCode);

	return isConnectionFailure(error);
}
